import React, { FormEvent, ReactElement } from 'react';
import { Heading } from 'idsk-react-components';
import { SafeParameterSetter } from '../../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../../model/PrispevokVestnikaStepEnum';
import DisabledAutorUpdate from './component/DisabledAutorUpdate';
import BasicDataStep1Component from './component/BasicDataStep1Component';
import CheckDataTable from '../../component/CheckDataTable';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  getFieldErrorMessage: (fieldName: string) => string;
  loading?: boolean;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const BasicDataStep1Update = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  getFieldErrorMessage,
  loading = false,
  onChange,
}: Props): ReactElement => (
  <div className="prispevok-vestnika-step-pages">
    <Heading className="page-title" size="xl">
      Úprava základných údajov
    </Heading>
    <DisabledAutorUpdate prispevokVestnika={prispevokVestnika} />
    <BasicDataStep1Component
      prispevokVestnika={prispevokVestnika}
      onSubmit={onSubmit}
      onUpdateField={onUpdateField}
      getFieldErrorMessage={getFieldErrorMessage}
      loading={loading}
    />
    <Heading size="m">Vaše odpovede</Heading>
    <CheckDataTable
      prispevokVestnika={prispevokVestnika}
      onChange={onChange}
      isUpdate
    />
  </div>
);

export default BasicDataStep1Update;
